import React from 'react'
import { browserHistory } from 'react-router'
import update from 'immutability-helper';
import { phoneNumberFormatter } from '../../../helpers/General/PhoneNunberFormatter'

import { modal } from '../../../core/utilities/modal'
import { adminUserAccounts } from '../../../core/controllers/Admin/AdminUserAccounts'

export default class AdminAdminEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            adminId: props.adminId,
            userAccountData: {
                'user': {
                    'user_type_alias': 'super-admin',
                    'username': '',
                    'password': ''
                },
                'user_data': {
                    'email': '',
                    'firstname': '',
                    'lastname': '',
                    'phone': '',
                    'company': '',
                },
                company: {
                    can_process_payments: 0
                }
            },
            confirmPassword: ""
        };
    }

    componentDidMount() {
        var self = this;
        if(!this.props.newAdmin) {
            //API to set userAccountData
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.userAccountData.user_type_alias === undefined || nextState.userAccountData.user_type_alias == "") {
            nextState.userAccountData.user_type_alias = "super-admin";
        }
    }

    handleEmailChange(e) {
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user_data: {
                    email: {
                        $set: e.target.value
                    },
                    username: {
                        $set: e.target.value
                    }
                }
            })
        });
    }

    handlePasswordChange(e) {
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user: {password: {$set: e.target.value}}
            })
        });
    }

    handleConfirmPasswordChange(e) {
        this.setState({
            confirmPassword: e.target.value
        });
    }

    handleFirstnameChange(e){
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user_data: {firstname: {$set: e.target.value}}
            })
        });
    }

    handleLastnameChange(e){
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user_data: {lastname: {$set: e.target.value}}
            })
        });
    }

    handleCompanyChange(e){
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user_data: {company: {$set: e.target.value}}
            })
        });
    }

    handlePhoneChange(e){
        var phoneNumber = phoneNumberFormatter.format(e.target.value);

        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user_data: {phone: {$set: phoneNumber}}
            })
        });
    }

    updateAdmin(e) {
        if(!this.validateData()){
            return;
        }
        //Waiting for API
    }

    deleteAdmin(e) {
        //Waiting for API
    }

    saveAdmin(e) {
        if(!this.validateData()){
            return;
        }
        //Waiting for API
    }

    validateData() {
        const enteredData = this.state.userAccountData;
        const email = enteredData.user_data.email;
        const password = enteredData.user.password;

        if (email.length == 0) {
            modal.showInfo("You need to enter an email address.", "danger", "top", "center");
            return false;
        }

        //Validate email
        const lastAtPos = email.lastIndexOf('@');
        const lastDotPos = email.lastIndexOf('.');
        if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') == -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
            modal.showInfo("Email is invalid.", "danger", "top", "center");
            return false;
        }

        if (password.length == 0) {
            modal.showInfo("You need to enter a password.", "danger", "top", "center");
            return false;
        }

        if (password != this.state.confirmPassword) {
            modal.showInfo("Confirmed password does not match.", "danger", "top", "center");
            return false;
        }

        return true;
    }

    render() {
        const newAdmin = this.props.newAdmin;
        const userAccountData = this.state.userAccountData;

        return (
        <div>
            <div class="row blue-bottom-margin">
                {newAdmin ? (
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">Add an Admin</span>
                        </div>
                    </div>
                </div>
                ) : (
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">{userAccountData.user_data.firstname} {userAccountData.user_data.lastname}</span>
                        </div>
                    </div>
                </div>
                )}
                <div class="col-md-12">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Admin Information</h4>
                            <p class="category"></p>
                        </div>
                        <div class="content">
                            <form>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label>Firstname</label>
                                            <input type="text" class="form-control" value={userAccountData.user_data.firstname} name="firstname" placeholder="Firstname" id="firstname" onChange={this.handleFirstnameChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label>Lastname</label>
                                            <input type="text" class="form-control" name="lastname" placeholder="Lastname" id="lastname" value={userAccountData.user_data.lastname} onChange={this.handleLastnameChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label>Email</label>
                                            <input type="text" class="form-control" name="email" placeholder="Email" id="email" value={userAccountData.user_data.email} onChange={this.handleEmailChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label>Phone</label>
                                            <input type="text" class="form-control" name="phone" placeholder="Phone Number" id="phone" value={userAccountData.user_data.phone} onChange={this.handlePhoneChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label>Password</label>
                                            <input type="password" class="form-control" value={userAccountData.user.password} name="password" placeholder="Password" id="Password" onChange={this.handlePasswordChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label>Confirm Password</label>
                                            <input type="password" class="form-control" value={this.state.confirmPassword} name="confirm_password" placeholder="Re-enter Password" id="confirm_password" onChange={this.handleConfirmPasswordChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label>Company</label>
                                            <input type="text" class="form-control" name="company" placeholder="Company" id="company" value={userAccountData.user_data.company} onChange={this.handleCompanyChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row blue-bottom">
                <div class="blue-bottom-center-align">
                    {newAdmin === false ? (
                    <div>
                        <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteAdmin.bind(this)}>
                            Delete Admin
                            </button>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <button type="button" id="save-user" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.updateAdmin.bind(this)}>
                            Update Admin
                            </button>
                        </div>
                    </div>
                    ) : (
                    <div>
                        <div class="col-md-12">
                            <button type="button" id="create-user" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.saveAdmin.bind(this)}>
                            Create Admin
                            </button>
                        </div>
                    </div>
                    )}
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Admin/Admin/AdminAdminEdit.jsx